import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newplaceholder.svg'


const _withScopeId = n => (_pushScopeId("data-v-ed241e6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.imageUrl !== null)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "slks-skeleton-image",
          onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loaded = true)),
          onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loaded = true)),
          src: _ctx.imageUrl,
          "data-testid-img": "",
          alt: ""
        }, null, 40, _hoisted_1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "slks-skeleton-image",
          src: _imports_0,
          onLoad: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loaded = true)),
          onError: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loaded = true)),
          "data-testid-img": "",
          alt: ""
        }, null, 32)),
    _createElementVNode("div", {
      class: _normalizeClass(["slks-skeleton-loader", { loaded: _ctx.loaded }]),
      "data-testid-skeleton": ""
    }, null, 2)
  ], 64))
}